var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.07,20C16.07,20,16.07,20,16.07,20H1.93C0.87,20,0,19.14,0,18.09c0-3.85,3.19-6.98,7.11-6.98h3.79 c3.92,0,7.11,3.13,7.11,6.98c0,0.5-0.2,0.98-0.55,1.34C17.08,19.8,16.59,20,16.07,20z M7.11,12.4c-3.22,0-5.83,2.55-5.83,5.69 c0,0.34,0.29,0.62,0.66,0.62h14.14h0c0.18,0,0.35-0.07,0.48-0.2c0.11-0.12,0.18-0.27,0.18-0.43c0-3.14-2.62-5.69-5.83-5.69H7.11z  M9,10.65c-2.99,0-5.42-2.39-5.42-5.32S6.01,0,9,0s5.42,2.39,5.42,5.32S11.99,10.65,9,10.65z M9,1.29c-2.28,0-4.14,1.81-4.14,4.03 S6.72,9.35,9,9.35s4.14-1.81,4.14-4.03S11.28,1.29,9,1.29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon_person.0bf97e21a5d5b4d42be569af20ba949c.svg";
export { ForwardRef as ReactComponent };